/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { EventsSeoFormComponent } from '@app/events/events/events-seo-form/events-seo-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Events } from '@app/events/events/events.model';

@Injectable({
  providedIn: 'root',
})
export class EventsSeoFormService {
  constructor(private modalService: NgbModal) {}

  public open(events: null | Events = null): Promise<any> {
    const modal = this.modalService.open(EventsSeoFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.eventSeo = events;
    return modal.result;
  }
}
